import React, { useState } from 'react';
import { Table, Input, Typography, Button, AutoComplete } from 'antd';
import axios from 'axios';
import { DeleteOutlined } from '@ant-design/icons';
import { workerURL } from '../Config';
import { useAppContext } from './AppContext';

const SuccessorComponent = ({ user, successorData, setsuccessorData }) => {
  const [searchResults, setSearchResults] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [loading, setLoading] = useState(false);
  const [employeeData, setEmployeeData] = useState(null);
  const { accessToken,idToken } = useAppContext();

  const handleSearch = async (value, record) => {
    setSearchTerm(value);
    setLoading(true);
    //console.log('Access Token:', accessToken);
    //console.log('URL:', `https://graph.microsoft.com/v1.0/users?$filter=startswith(displayName,'${value}')`);
    const url = `https://graph.microsoft.com/v1.0/users?$filter=startswith(displayName,'${value}')`;
    try {
      const response = await axios.get(url, {
        headers: {
          Authorization: `Bearer ${accessToken}` // Include access token in headers
        }
      });
      //console.log('response:', response);
      setSearchResults(response.data.value.map(user => ({ value: user.displayName, user })));
      record.empnameSuggestions = response.data.value.map(user => ({ value: user.displayName, user }));
    } catch (error) {
      //console.error('Error fetching user data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelect = (value, record, option) => {
    //console.log('option:', record);
    //console.log('value', value);
    //console.log('option', option);

    fetch(workerURL + `/${option.user.userPrincipalName}`,{
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${idToken}`  // Include the bearer token here
      }
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch data');
        }
        return response.json();
      })
      .then(data => {
        setEmployeeData(data);
        //console.log('Data:', data);
        record.manager = data.managerName;
        record.title = data.jobTitle;
        record.readiness = data.readiness;
        record.successorMailID = data.userPrincipalName;
        record.empMailID = user.userPrincipalName;
        setsuccessorData([...data]);
      })
      .catch(error => {
        //console.error('Error fetching data:', error);
      });
  };



  const handleInputChange = (key, value) => {
    //console.log(value);
    //console.log(key);
    const newData = [...successorData];
    const index = newData.findIndex((item) => key === item.successorMailID);
    newData[index].comments = value;
    setsuccessorData(newData);
  };

  const addNewRow = () => {
    const newRow = {};

    setsuccessorData([...successorData, newRow]);
  };

  const columns = [


    {
      title: 'Employee Name',
      dataIndex: 'empName',
      key: 'empName',
      width: 100,
      render: (text, record) => (
        <AutoComplete
          placeholder="Successor Not Identified"
          options={record.empnameSuggestions}
          value={record.empName}
          onSearch={(value) => handleSearch(value, record)}
          onSelect={(value, option) => handleSelect(value, record, option)}
          style={{
            width: 250,
          }}
        />

      ),
    },

    {
      title: 'Manager',
      dataIndex: 'manager',
      key: 'manager',
      width: 200,
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
      width: 200,
    },
    {
      title: 'Promotion Readiness',
      dataIndex: 'readiness',
      key: 'readiness',
      width: 200,
    },
    {
      title: 'Comments',
      dataIndex: 'comments',
      key: 'comments',
      render: (text, record) => (
        <Input.TextArea
          value={text}
          autoSize={{ minRows: 3, maxRows: 3 }} // Set the number of rows
          onChange={(e) => handleInputChange(record.successorMailID, e.target.value)}
          style={{ overflowY: 'auto', width: '300px' }}
        />
      ),
    },
    {
      title: 'Remove',
      key: 'action',
      render: (text, record) => (
        <Button
          type="link"
          icon={<DeleteOutlined />}
          onClick={() => handleDelete(record.successorMailID)}
        />
      ),
    }
  ];

  const handleDelete = (key) => {
    // Implement your delete logic here
    //console.log('Delete record with key:', key);
    setsuccessorData(successorData.filter((item) => item.successorMailID !== key));
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }} >
        <h2>Successor for this role</h2>

        <Button type="primary" onClick={addNewRow}>Add Successor</Button>
      </div>
      <Table
        columns={columns}
        dataSource={successorData}
        bordered
        pagination={false}

      />
    </div>

  );
};

export default SuccessorComponent;
